import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GoogleContactsService from '../services/GoogleContactsService';
import { parseOAuthCallback } from '../utils/oauth/oauthUtils';

/**
 * Contacts OAuth Callback Component
 * Handles OAuth redirects for Google Contacts integration
 * Processes the OAuth callback and stores the result for InviteFriendsModal
 */
const ContactsOAuthCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Processing Google Contacts authentication...');

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const params = parseOAuthCallback();
      
      // Get return URL from localStorage (set by InviteFriendsModal)
      const returnUrl = localStorage.getItem('google_contacts_return_url') || '/Social';
      
      if (params.code && !params.error) {
        try {
          setStatus('Exchanging authorization code for access token...');
          
          // Exchange authorization code for access token
          const accessToken = await GoogleContactsService.handleOAuthCallback(params.code);
          
          // Initialize gapi client with the token
          await GoogleContactsService.initialize();
          if (GoogleContactsService.gapi?.client) {
            GoogleContactsService.gapi.client.setToken({ access_token: accessToken });
          }
          
          // Store success result in localStorage for InviteFriendsModal to pick up
          localStorage.setItem('google_contacts_oauth_result', JSON.stringify({
            success: true,
            accessToken: accessToken,
            timestamp: Date.now()
          }));
          
          setStatus('Authentication successful! Redirecting...');
          
          // Clear URL parameters and redirect
          window.history.replaceState({}, document.title, returnUrl);
          navigate(returnUrl, { replace: true });
          
        } catch (error) {
          console.error('Error handling contacts OAuth callback:', error);
          
          // Store error result
          localStorage.setItem('google_contacts_oauth_result', JSON.stringify({
            success: false,
            error: error.message || 'Authentication failed',
            timestamp: Date.now()
          }));
          
          setStatus('Authentication failed. Redirecting...');
          
          // Redirect back even on error
          window.history.replaceState({}, document.title, returnUrl);
          navigate(returnUrl, { replace: true });
        }
      } else if (params.error) {
        // Handle OAuth error
        localStorage.setItem('google_contacts_oauth_result', JSON.stringify({
          success: false,
          error: params.error_description || params.error || 'Authentication was cancelled',
          timestamp: Date.now()
        }));
        
        setStatus('Authentication cancelled or failed. Redirecting...');
        
        // Clear URL and redirect
        window.history.replaceState({}, document.title, returnUrl);
        navigate(returnUrl, { replace: true });
      } else {
        // No OAuth params, just redirect
        navigate(returnUrl, { replace: true });
      }
      
      // Clean up stored values
      localStorage.removeItem('google_contacts_return_url');
      localStorage.removeItem('google_contacts_modal_open');
    };

    handleOAuthCallback();
  }, [navigate]);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>{status}</p>
    </div>
  );
};

export default ContactsOAuthCallback;

